const quickLinks = [
  { label: 'Sobre o Escritório', href: '#sobre' },
  { label: 'Serviços', href: '#servicos' },
  { label: 'Equipe', href: '#equipe' },
  { label: 'Como Atuamos', href: '#como-atuamos' },
  { label: 'Contato', href: '#contato' },
];

const services = [
  'Direito Societário',
  'Contratos Empresariais',
  'Recuperação Judicial',
  'Planejamento Patrimonial',
  'Leilões Judiciais',
  'Agronegócio',
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer style={{ background: '#0F3B2E' }}>
      {/* Gold top line */}
      <div className="h-px bg-gradient-to-r from-transparent via-kpr-gold/40 to-transparent" />

      {/* Main footer */}
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <img
              src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/5b523bf4e9f873538aefa42204d27026.png"
              alt="KPR Advogados Associados"
              className="w-auto object-contain mb-6"
              style={{ height: '92px' }}
            />
            <p className="text-white/55 text-sm leading-loose mb-6 font-light">
              Advocacia empresarial estratégica para empresas e investidores em todo o Brasil,
              com foco em PR e SC.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/kpradvogados"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center border border-white/20 hover:border-kpr-gold text-white/50 hover:text-kpr-gold transition-all duration-300 cursor-pointer"
                aria-label="Instagram KPR Advogados"
              >
                <i className="ri-instagram-line text-sm w-4 h-4 flex items-center justify-center" />
              </a>
              <a
                href="https://wa.me/5541992570505"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-9 h-9 flex items-center justify-center border border-white/20 hover:border-kpr-gold text-white/50 hover:text-kpr-gold transition-all duration-300 cursor-pointer"
                aria-label="WhatsApp KPR Advogados"
              >
                <i className="ri-whatsapp-line text-sm w-4 h-4 flex items-center justify-center" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-serif text-white/70 font-light text-sm tracking-[0.2em] uppercase mb-6">
              <a href="#inicio">Links Rápidos</a>
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-white/45 hover:text-kpr-gold text-sm font-light transition-colors duration-200 flex items-center gap-2 cursor-pointer"
                  >
                    <span className="w-3 h-px bg-white/30 transition-colors" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-serif text-white/70 font-light text-sm tracking-[0.2em] uppercase mb-6">
              <a href="#servicos">Áreas de Atuação</a>
            </h4>
            <ul className="space-y-3">
              {services.map((s) => (
                <li key={s}>
                  <a
                    href="#servicos"
                    className="text-white/45 hover:text-kpr-gold text-sm font-light transition-colors duration-200 flex items-center gap-2 cursor-pointer"
                  >
                    <span className="w-3 h-px bg-white/30 transition-colors" />
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-serif text-white/70 font-light text-sm tracking-[0.2em] uppercase mb-6">
              <a href="#contato">Contato</a>
            </h4>
            <div className="space-y-5">
              <a
                href="https://wa.me/5541992570505"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="flex items-start gap-3 group cursor-pointer"
              >
                <i className="ri-whatsapp-line text-kpr-gold/70 w-4 h-4 flex items-center justify-center mt-0.5" />
                <span className="text-white/45 group-hover:text-kpr-gold/80 text-sm font-light transition-colors">(41) 99257-0505</span>
              </a>
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-line text-kpr-gold/70 w-4 h-4 flex items-center justify-center mt-0.5 shrink-0" />
                <span className="text-white/45 text-sm leading-relaxed font-light">
                  R. Padre Agostinho, 2960<br />
                  São Francisco – Curitiba/PR<br />
                  CEP 80710-000
                </span>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-global-line text-kpr-gold/70 w-4 h-4 flex items-center justify-center mt-0.5 shrink-0" />
                <span className="text-white/45 text-sm font-light">Atuação Nacional</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="h-px bg-white/10 mx-8" />

      {/* Bottom bar */}
      <div className="max-w-7xl mx-auto px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <div className="text-white/40 text-xs font-light text-center sm:text-left tracking-wide">
          &copy; {year} <span className="text-white/55">KPR Advogados Associados</span>
          {' '}– CNPJ 31.287.813/0001-38
        </div>
        <div className="flex items-center gap-5">
          <a href="#sobre" className="text-white/40 hover:text-kpr-gold/70 text-xs font-light tracking-wide transition-colors cursor-pointer">
            Política de Privacidade
          </a>
          <span className="text-white/20">|</span>
          <a
            href="https://startdigital1.com.br"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-white/40 hover:text-kpr-gold/70 text-xs font-light tracking-wide transition-colors cursor-pointer"
          >
            Desenvolvido por Start Digital
          </a>
        </div>
      </div>
    </footer>
  );
}
